import { forwardRef } from 'react';
import { Sheet, Stack } from '@mui/joy';
import { WeeklyCalendarHeader } from '@/components/calendar/WeeklyCalendarHeader';
import { WeekdaySelector } from '@/components/calendar/WeekdaySelector';
import { ModeSwitcher } from '@/features/meals/components/ModeSwitcher';

export const MealsWeeklyHeader = forwardRef(function MealsWeeklyHeader({ currentWeek, weekDaysWithMeals, selectedDate, onSelectDate, mealCount, weekStartDay }, ref) {
  return (
    <Sheet
      ref={ref}
      variant="plain"
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        mx: -2,
        p: 2,
        pt: 1.5,          
        backgroundColor: '#fff',
        boxShadow: 'rgba(20, 23, 26, 0.05) 0px 1px 3px',        
      }}
    >
      <Stack gap={1.5}>
        <WeeklyCalendarHeader
          mealCount={mealCount}
          currentWeekStart={currentWeek}
          onDateChange={onSelectDate}
          weekStartDay={weekStartDay}
          selectedDate={selectedDate}
        />
        <WeekdaySelector
          days={weekDaysWithMeals}
          selectedDate={selectedDate}
          onSelectDate={onSelectDate}
        />
        <ModeSwitcher />
      </Stack>
    </Sheet>
  );
});